<!--
    课程分享-课时编辑-课件列表-左边分类组件
    作用：展示校区学科分类
    说明：版本3.0
-->
<template>
  <div class="left-demo" v-loading="isLoading">
  <el-form ref="form" label-width="50px" size="medium">
      <el-form-item label="校区:">
        <el-select v-model="schoolVal" placeholder="请选择校区" @change="changeSchool">
          <el-option v-for="item in schoolOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学科:">
        <el-select v-model="categoryVal" placeholder="请选择学科" @change="changeCategory">
          <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      </el-form>
      <div class="tree-demo">
      <el-tree
      ref="tree"
      @node-click="clickNode"
      @check="checkChange"
      :data="typeTree"
      show-checkbox
      node-key="id"
      :props="defaultProps">
      </el-tree>
      </div>
    </div>
</template>
<script>
import { fetchSchools, fetchCategoryChild } from '@/api/courseOn'
export default {
  name: 'leftSelect',
  data () {
    return {
      isLoading: false,
      schoolVal: '',
      schoolOptions: [],
      categoryVal: '',
      categoryOptions: [],
      allCategorys: [], // 校区下所以学校数据
      typeTree: [], // 分类数据
      checkNodes: [], // 已选中的所有节点
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  mounted () {
    this.getSchools()
  },
  methods: {
    // 获取校区列表
    getSchools () {
      this.isLoading = true
      fetchSchools(this.$store.state.choicesSchool.id).then(res => {
        res.school.forEach(item => {
          const { id, name } = item
          this.schoolOptions.push({
            value: id,
            label: name
          })
        })
        this.isLoading = false
      })
    },
    // 获取校区下的学科
    getCategory (id) {
      this.isLoading = true
      fetchCategoryChild(id).then(res => {
        const newArr = []
        this.allCategorys = res.data.length ? res.data : []
        res.data.forEach(item => {
          const { id, name } = item
          newArr.push({
            value: id,
            label: name
          })
        })
        this.categoryOptions = newArr
        this.categoryVal = newArr.length ? newArr[0].value : ''
        const val = newArr.length ? newArr[0].value : null
        this.changeCategory(val)
        this.isLoading = false
      })
    },
    // 切换学校
    changeSchool (val) {
      this.getCategory(val)
    },
    // 切换学科
    changeCategory (val) {
      const data = this.allCategorys.filter(item => item.id === val)
      if (data.length) {
        this.typeTree = this.transData(data[0].childrens)
      } else {
        this.typeTree = []
      }
    },
    // 学科子类数据回调
    transData (data) {
      const fun = (data) => {
        const newArr = []
        data.forEach(item => {
          const { id, name } = item
          const obj = {
            id,
            label: name
          }
          if (item.childrens.length)obj.children = fun(item.childrens)
          newArr.push(obj)
        })
        return newArr
      }
      return fun(data)
    },
    // tree - check
    checkChange (event, checknodes) {
      console.log('点击节点复选框', event, checknodes)
      const checkIds = []
      checknodes.checkedNodes.forEach(item => {
        const { id } = item
        checkIds.push(id)
      })
      this.checkNodes = checkIds
      this.$refs['tree'].setCurrentKey(event.id)
      const isSate = this.checkNodes.includes(event.id)
      this.$emit('nodeCheck', event.id, isSate)
    },
    // tree -chick
    clickNode (val) {
      console.log('点击节点', val)
      this.$emit('nodeClick', val.id)
    }
  }
}
</script>
<style lang="scss" scoped>
.left-demo{
  .tree-demo{
    padding-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/courseList/components/leftSelect.vue